import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Workspace from "@/pages/Workspace";
import Portal from "@/pages/Portal";
import SetPassword from "@/pages/SetPassword";
import Terms from "@/pages/Terms";
import { Loader2 } from "lucide-react";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
        <Loader2 className="h-8 w-8 animate-spin text-[#C1121F]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  const isConsumer = user.role === "consumer";
  if (role === "agency" && isConsumer) return <Navigate to="/portal" replace />;
  if (role === "consumer" && !isConsumer) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/app" element={<Protected role="agency"><Workspace /></Protected>} />
            <Route path="/portal" element={<Protected role="consumer"><Portal /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
